import { useState } from 'react'

import { useAppSelector } from 'app/hooks'

import {
  ISystemGraphsViewProps,
  QRAGraphType
} from 'features/RiskManagement/Components/Graphs'
import { GraphComponentById } from 'features/RiskManagement/Components/Graphs/graphComponentById'
import {
  getRiskForecastRowClassName,
  RiskForecastGraphs
} from 'features/RiskManagement/Components/Graphs/Implementations/RiskForecastGraphs'
import {
  selectRiskUnit,
  selectSavedFilter
} from 'features/RiskManagement/Components/LocalFilter/localFilterSelectors'

import { GraphGrid, type GraphGridItem } from './GraphGrid'

const standardLayout: GraphGridItem<QRAGraphType>[] = [
  {
    graphType: QRAGraphType.THREATS,
    rowClassName: 'comparisonBreakdown'
  },
  {
    graphType: QRAGraphType.CONSEQUENCES,
    rowClassName: 'comparisonBreakdown'
  },
  {
    graphType: QRAGraphType.RISK_BY_LINE,
    rowClassName: 'linearReference'
  },
  {
    graphType: QRAGraphType.RISK_FORECAST,
    rowClassName: 'forecast'
  },
  {
    graphType: QRAGraphType.RISK_BY_SIGNIFICANCE_LEVEL,
    rowClassName: 'riskSummary'
  },
  {
    graphType: QRAGraphType.RISK_BY_SYSTEM,
    rowClassName: 'riskSummary'
  }
]

const getSystemViewGraphGridItems = (
  riskForecastGraphType: RiskForecastGraphs
): GraphGridItem<QRAGraphType>[] =>
  standardLayout.map((item) => {
    if (item.graphType !== QRAGraphType.RISK_FORECAST) {
      return item
    }

    return {
      ...item,
      rowClassName: getRiskForecastRowClassName(riskForecastGraphType)
    }
  })

const GraphsView = ({
  qraViewBasePath,
  showLoading,
  charts = {},
  riskByPipelineLengthGraphData,
  riskBySystemGraphData,
  hasLineViewNavigation,
  itemsFromGraphType,
  graphLoadingByType,
  csvExportParams
}: ISystemGraphsViewProps) => {
  const localFilter = useAppSelector(selectSavedFilter)
  const riskUnit = useAppSelector(selectRiskUnit)
  const [riskForecastGraphType, setRiskForecastGraphType] =
    useState<RiskForecastGraphs>(RiskForecastGraphs.ByThreat)

  const layout = getSystemViewGraphGridItems(riskForecastGraphType)

  return (
    <GraphGrid items={layout} testId='system-graphs-grid'>
      {({ graphType }) => (
        <GraphComponentById
          graphType={graphType}
          showLoading={showLoading}
          graphLoading={graphLoadingByType?.[graphType]}
          charts={charts}
          riskByPipelineLengthGraphData={riskByPipelineLengthGraphData}
          riskBySystemGraphData={riskBySystemGraphData}
          riskUnit={riskUnit}
          localFilter={localFilter}
          qraBasePath={hasLineViewNavigation ? qraViewBasePath : undefined}
          itemsFromGraphType={itemsFromGraphType}
          csvExportParams={csvExportParams}
          onRiskForecastGraphTypeChange={setRiskForecastGraphType}
        />
      )}
    </GraphGrid>
  )
}

export default GraphsView
